import React from 'react';

const CustomCheckbox = ({ label, name, errors = [], checked, ...props }) => {

  return (
    <div className={`flex items-center mb-5 w-full pb-6 pr-6`}>
      {label && (
        <label className="form-label mb-0 mr-2.5" htmlFor={name}>
          {label}:
        </label>
      )}
      <div className={'mr-2'}>
        <input
          id={name}
          name={name}
          {...props}
          checked={!!checked}
          type={'checkbox'}
          multiple
          className={''}
        />
      </div>
      {errors && <div className="form-error">{errors}</div>}
    </div>
  );
};

export default CustomCheckbox;
